import normalize from 'normalize-object';
import { PublicEmbed } from '@wix/wix-vod-api-site-based/public';
import { parseVidiUrls } from '../utils';
import { mapMediaInfoToLiveVideoStatus } from '@wix/wix-vod-api-site-based';
import { removeDashes, setInstanceGetter } from '@wix/wix-vod-shared/common';
import { HttpClient } from '@wix/http-client';

const httpClient = new HttpClient();
const getIdFromItemId = (itemId) => itemId.split('-')[1];
const authorization = window.__AUTHORIZATION_TOKEN__;

setInstanceGetter(() => authorization);

const v3ToV2MappingBaseURL = '/_api/vod/public/v3-to-v2';

const createEmbedService = () =>
  new PublicEmbed(httpClient, v3ToV2MappingBaseURL);

export const getChannelData = ({ channelId, instanceId }) => {
  return createEmbedService()
    .getChannelInfo(removeDashes(channelId), instanceId)
    .then((response) => response.data)
    .then((channelInfo) => normalize(channelInfo))
    .then((channelData) => ({
      ...channelData,
      id: getIdFromItemId(channelData.itemId),
    }));
};

export const getEmbedVideo = ({ channelId, videoId, instanceId }) => {
  return createEmbedService()
    .getVideoInfo(removeDashes(videoId), removeDashes(channelId), instanceId)
    .then((response) => response.data)
    .then((videoInfo) => normalize(videoInfo).itemInfo)
    .then((videoItem) => {
      const { itemType, mediaInfo } = videoItem;

      return {
        ...videoItem,
        id: getIdFromItemId(videoItem.itemId),
        liveVideoStatus: mapMediaInfoToLiveVideoStatus(mediaInfo, itemType),
      };
    });
};

export const getSiteUrl = ({
  instanceId,
  pathToPage = '',
  videoId,
  compId,
}) => {
  return createEmbedService()
    .getSiteUrlByInstanceId(instanceId)
    .then((response) => normalize(response.data))
    .then(
      (data) =>
        `${data.publicUrl}${pathToPage}?wix-vod-video-id=${videoId}&wix-vod-comp-id=${compId}`,
    );
};

export const getVideoUrls = ({ videoId, channelId, instanceId }) => {
  return createEmbedService()
    .getVideoUrls(removeDashes(videoId), removeDashes(channelId), instanceId)
    .then((response) => response.data)
    .then((videoUrls) => normalize(videoUrls))
    .then((videoUrls) => parseVidiUrls(videoUrls));
};

export const getVideoCards = ({ channelId, videoId, instanceId }) => {
  return createEmbedService()
    .getVideoCards(removeDashes(channelId), removeDashes(videoId), instanceId)
    .then((response) => response.data)
    .then((videoCards) => normalize(videoCards));
};
